import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.svg',
    styleUrls: ['./logout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent {}
